export default __webpack_public_path__ + "static/media/patient-small-white.146fd160.svg";